/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_Document_TypeInputs */



/**
* | output |
* | --- |
* | "Wundo cannot read that kind of file. Choose a PDF, text, Word or PowerPoint file." |
*
* @param {Meeting_Sources_Document_TypeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_document_type = /** @type {((inputs?: Meeting_Sources_Document_TypeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_Document_TypeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo kan dat soort bestand niet lezen. Kies een pdf, tekst-, Word- of PowerPoint-bestand.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo ne sait pas lire ce type de fichier. Choisissez un PDF, un fichier texte, Word ou PowerPoint.")
	return /** @type {LocalizedString} */ ("Wundo cannot read that kind of file. Choose a PDF, text, Word or PowerPoint file.")
});